import { createApp } from 'vue'
import './assets/styles/style.css'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import { createPinia } from 'pinia'
import { router } from './router/router.js'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 域名与标题的映射关系
const domainTitleMap = {
  'wuliu178.com': '物流178',
  'wuliu369.com': '物流369'
  // 可以添加更多域名和对应的标题
}

// 根据域名获取标题
const getTitleByDomain = () => {
  const currentDomain = window.location.hostname;
  console.log('当前域名:', currentDomain);
  
  // 遍历映射关系，查找匹配的域名
  for (const domain in domainTitleMap) {
    if (currentDomain.includes(domain)) {
      return domainTitleMap[domain];
    }
  }
  
  // 默认标题
  return '物流聚合平台';
}

// 根据域名设置页面标题
document.title = getTitleByDomain();

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.mount('#app')